import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import GenericSpinner from "@kikoff/components/src/v1/animations/GenericSpinner";
import useErrorConsumer from "@kikoff/hooks/src/useErrorConsumer";

import PaymentMethodEntry from "@component/payment/payment_method_entry";
import {
  PaymentMethodSelection,
  PaymentMethodSelectionProps,
} from "@component/payment/payment_method_selection";
import { selectCreditAccount } from "@feature/credit_line";
import { fetchPaymentMethods, selectHasPaymentMethod } from "@feature/funds";

interface PaymentMethodProps {
  className?: string;
  onPaymentMethodTokenChange(token: string): void;
  onValidChange(valid: boolean): void;
  paymentOptions?: PaymentMethodSelectionProps["paymentOptions"];
}

function PaymentMethod({
  className,
  onPaymentMethodTokenChange,
  onValidChange,
  paymentOptions: _paymentOptions,
}: PaymentMethodProps) {
  const dispatch = useDispatch();
  const error = useErrorConsumer();

  const hasPaymentMethod = useSelector(selectHasPaymentMethod("CARD"));
  const preview = useSelector((state) => state.shopping.checkoutPreview);
  const creditLine = useSelector(selectCreditAccount());

  const paymentOptions =
    (preview || creditLine)?.paymentOptions ?? _paymentOptions;

  useEffect(() => {
    if (!hasPaymentMethod)
      dispatch(fetchPaymentMethods()).catch((e) => {
        error.throw(e.message);
      });
  }, []);

  return (
    <div className={className}>
      {(() => {
        if (hasPaymentMethod) {
          if (paymentOptions) {
            return (
              <PaymentMethodSelection
                paymentOptions={paymentOptions}
                onPaymentMethodTokenChange={onPaymentMethodTokenChange}
              />
            );
          }

          return <GenericSpinner size="24px" center />;
        }

        return <PaymentMethodEntry onValidChange={onValidChange} />;
      })()}
    </div>
  );
}

export default PaymentMethod;
